import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { FiDatabase, FiLayers, FiMonitor, FiServer, FiSmartphone, FiCode, FiCpu, FiTrendingUp } from "react-icons/fi";
import HeroBanner from "../components/HeroBanner";
import SectionWrapper from "../components/SectionWrapper";
import softwareHero from "../assets/software-hero.jpg";

const customSoftware = [
  { icon: FiDatabase, title: "ERP & CRM Systems", desc: "Streamline operations with custom enterprise resource planning and customer relationship management solutions." },
  { icon: FiLayers, title: "SaaS Platforms", desc: "Build multi-tenant, subscription-based platforms with scalable cloud architecture." },
  { icon: FiMonitor, title: "Enterprise Dashboards", desc: "Real-time analytics and KPI monitoring dashboards for data-driven decision making." },
  { icon: FiServer, title: "API & System Integrations", desc: "Connect disparate systems with robust API development and third-party integrations." },
];

const webMobile = [
  "Responsive Business Websites",
  "Progressive Web Apps (PWA)",
  "Android & iOS Applications",
  "Admin Panels & Portals",
];

const aiData = [
  "Business Intelligence Dashboards",
  "AI-Based Recommendation Systems",
  "Process Automation",
  "Predictive Analytics",
];

const SoftwareSolutions = () => {
  return (
    <>
      <HeroBanner
        image={softwareHero}
        title="Software Solutions"
        subtitle="We design and build secure, scalable, and high-performance software tailored to your business needs."
      />

      <SectionWrapper>
        <div className="text-center mb-12">
          <h2 className="section-title mb-4">Custom Software <span className="text-primary">Development</span></h2>
          <p className="section-subtitle mx-auto">Tailored solutions that drive efficiency and growth for your business.</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {customSoftware.map((item, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.1 }}
              className="card-hover flex gap-5"
            >
              <item.icon className="w-12 h-12 text-primary flex-shrink-0" />
              <div>
                <h3 className="font-montserrat font-bold text-lg mb-2">{item.title}</h3>
                <p className="text-muted-foreground font-roboto text-sm leading-relaxed">{item.desc}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </SectionWrapper>

      <SectionWrapper className="bg-muted">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
          <motion.div initial={{ opacity: 0, x: -30 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }}>
            <FiSmartphone className="w-12 h-12 text-primary mb-4" />
            <h2 className="text-2xl md:text-3xl font-montserrat font-bold mb-6">Web & Mobile <span className="text-primary">Development</span></h2>
            <ul className="space-y-3">
              {webMobile.map((item, i) => (
                <li key={i} className="flex items-center gap-3">
                  <FiCode className="w-5 h-5 text-primary flex-shrink-0" />
                  <span className="font-roboto text-muted-foreground">{item}</span>
                </li>
              ))}
            </ul>
            <Link to="/services/web-app-development" className="btn-primary mt-6 text-sm">Learn More</Link>
          </motion.div>

          <motion.div initial={{ opacity: 0, x: 30 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }}>
            <FiCpu className="w-12 h-12 text-primary mb-4" />
            <h2 className="text-2xl md:text-3xl font-montserrat font-bold mb-6">AI, Data & <span className="text-primary">Automation</span></h2>
            <ul className="space-y-3">
              {aiData.map((item, i) => (
                <li key={i} className="flex items-center gap-3">
                  <FiTrendingUp className="w-5 h-5 text-primary flex-shrink-0" />
                  <span className="font-roboto text-muted-foreground">{item}</span>
                </li>
              ))}
            </ul>
            <Link to="/services/ai-data-automation" className="btn-primary mt-6 text-sm">Learn More</Link>
          </motion.div>
        </div>
      </SectionWrapper>

      <SectionWrapper className="bg-primary text-primary-foreground text-center">
        <h2 className="text-3xl md:text-4xl font-montserrat font-bold mb-4">Need Custom Software?</h2>
        <p className="text-primary-foreground/80 font-roboto text-lg mb-8 max-w-2xl mx-auto">Let us build the perfect solution for your business.</p>
        <Link to="/contact" className="btn-hero-outline">Get a Free Quote</Link>
      </SectionWrapper>
    </>
  );
};

export default SoftwareSolutions;
